// import { toPng } from "html-to-image";
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "components/app/dialog/dialog";
import { QrCode } from "lucide-react";
import { QRCode } from "react-qrcode-logo";
import { cn } from "lib/utils";
import html2canvas from "html2canvas";
import useClipboard from "react-use-clipboard";
import { saveAs } from "file-saver";
import { faArrowLeft, faArrowRight, faDownload } from "@fortawesome/free-solid-svg-icons";

import { backgroundMenu, backgroundQrClickTime, logoMaxxBlack, logoMoowResturant, logoQrDefaultMenu, noImageAvialable } from "assets";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { useEffect, useRef, useState } from "react";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { AppLog } from "services";
import { Service } from "utils/services";
export default function QrCodeTimesheetGenerater({ className, userShop, logoIcon = null }: { className?: string; userShop: any; logoIcon?: any }) {
  const elementRef = useRef<HTMLDivElement>(null);
  const [isDownloadQr, setIsDownloadQr] = useState<boolean>(false);
  const [isLoadingAPI, setIsLoadingAPI] = useState<boolean>(false);
  const [shopShiftGroup, setShopShiftGroup] = useState<any[]>([]);
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const imageUrlUserProfile = userShop?.thumbnail?.startsWith("http://") ? userShop?.thumbnail.replace("https://", "http://") : userShop?.thumbnail;

  const [isCopied, setCopied] = useClipboard(shopShiftGroup[currentIndex]?.clock_time_url, {
    successDuration: 1000,
  });

  const downloadQRMenu = async () => {
    setIsDownloadQr(true);
    if (elementRef.current) {
      try {
        // Set styles dynamically
        const element = elementRef.current;
        await new Promise((resolve) => setTimeout(resolve, 1000));
        // Render to canvas
        const canvas = await html2canvas(element, {
          useCORS: false,
          allowTaint: false,
          logging: false,
          scale: 2,
          imageTimeout: 0,
          proxy: `${process.env.REACT_APP_API_URL}/get-image-url`,
        });
        // Convert canvas to Blob and download
        canvas.toBlob((blob) => {
          if (blob) saveAs(blob, "qr-menu.png");
        }, "image/png");
      } catch (error) {
        console.error("Error generating QR code:", error);
      } finally {
        setIsDownloadQr(false);
      }
    }
  };

  const fetchGetTimesheet = async () => {
    try {
      setIsLoadingAPI(true);
      let url: string = "";
      url = RouteApi.getShopShiftGroup;
      url += `token=${Service.token}`;

      const data = {
        shop_id: userShop?.shop_id,
      };

      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setShopShiftGroup(response["user_shop_shift_groups"]);
      } else {
        AppLog.show({ message: response.msg, status: StatusMsg.getType(response.status) });
      }
    } catch (error) {
      AppLog.show({
        message: `[fetchGetTimesheet]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setIsLoadingAPI(false);
    }
  };

  const previousBackground = () => {
    if (!shopShiftGroup || shopShiftGroup.length === 0) return;
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? shopShiftGroup?.length - 1 : prevIndex - 1));
  };

  const nextBackground = () => {
    if (!shopShiftGroup || shopShiftGroup.length === 0) return;
    setCurrentIndex((prevIndex) => (prevIndex === shopShiftGroup?.length - 1 ? 0 : prevIndex + 1));
  };

  useEffect(() => {
    if (isDialogOpen) {
      fetchGetTimesheet();
    }
  }, [isDialogOpen]);

  return (
    <Dialog onOpenChange={setIsDialogOpen}>
      {/* ratio Qr: 1454 × 2048 */}
      <DialogTrigger className={cn(`cursor-pointer`, className)} asChild>
        {logoIcon === null ? <QrCode className="filter invert-0 brightness-100 dark:invert dark:brightness-0" /> : logoIcon}
      </DialogTrigger>
      <DialogContent className="overflow-hidden text-black">
        <DialogTitle></DialogTitle>
        <div ref={elementRef} className="aspect-[1454/2048] flex flex-col">
          <div style={{ backgroundImage: `url("${backgroundQrClickTime}")` }} className={`fixed top-0 left-0 bg-cover h-full w-full rounded-md -z-50`} />
          <div className="text-md italic mt-8 ml-8">
            Member of
            <img className="h-[30px] w-auto filter grayscale contrast-200 brightness-0 mt-2" src={logoMaxxBlack} alt="Logo of Maxx Black" />
          </div>
          <div className="text-center font-medium mt-2 mb-2">
            <h1 className="text-lg">QR Clock Time</h1>
            <p>Scan. Clock Time. Done.</p>
          </div>

          <div className={`${isDownloadQr ? "hidden" : "block"} absolute space-x-2 -top-2 left-6 flex justify-center mt-4 z-50`}>
            <button onClick={previousBackground} className="w-[30px] h-[30px] text-gray-700 bg-white hover:bg-gray-200 rounded-full">
              <FontAwesomeIcon icon={faArrowLeft} />
            </button>
            <button onClick={nextBackground} className="w-[30px] h-[30px] text-gray-700 bg-white hover:bg-gray-200 rounded-full">
              <FontAwesomeIcon icon={faArrowRight} />
            </button>
          </div>

          <div className="absolute space-x-2 -top-2 right-16 flex justify-center mt-4">
            <button onClick={setCopied} className="w-[30px] h-[30px] text-gray-700 bg-white hover:bg-gray-200 rounded-full">
              <FontAwesomeIcon icon={faCopy} />
            </button>

            <button onClick={downloadQRMenu} className="w-[30px] h-[30px] text-gray-700 bg-white hover:bg-gray-200 rounded-full">
              <FontAwesomeIcon icon={faDownload} />
            </button>
          </div>

          <div className={`${isDownloadQr ? "hidden" : "block"} absolute space-x-2 -top-2 right-16 flex justify-center mt-4 z-50`}>
            <button className="w-[30px] h-[30px] text-gray-700 bg-white hover:bg-gray-200 rounded-full" onClick={setCopied}>
              <FontAwesomeIcon icon={faCopy} />
            </button>
            {isCopied && <span className="absolute top-10 right-8 text-green-500 text-xs">Copied!</span>}
            <button onClick={downloadQRMenu} className="w-[30px] h-[30px] text-gray-700 bg-white hover:bg-gray-200 rounded-full" aria-label="Download QR Code">
              <FontAwesomeIcon icon={faDownload} />
            </button>
          </div>

          <div className="relative flex justify-center items-center">
            <div className="relative inline-block">
              <QRCode
                value={shopShiftGroup[currentIndex]?.clock_time_url}
                size={200}
                ecLevel="Q"
                fgColor="#1D1615"
                bgColor="transparent"
                qrStyle="squares" // Makes the QR code dots rounded
                quietZone={10}
                eyeRadius={[
                  [50, 50, 50, 50],
                  [50, 50, 50, 50],
                  [50, 50, 50, 50],
                ]}
              />

              <div className="absolute top-0 left-0 pointer-events-none">
                {/* Top-left corner */}
                <div className="w-[25px] h-[25px] border-t-2 border-l-2 border-[#1D1615] rounded-tl-2xl"></div>
              </div>
              <div className="absolute top-0 right-0 pointer-events-none">
                {/* Top-right corner */}
                <div className="w-[25px] h-[25px] border-t-2 border-r-2 border-[#1D1615] rounded-tr-2xl"></div>
              </div>
              <div className="absolute bottom-0 left-0 pointer-events-none">
                {/* Bottom-left corner */}
                <div className="w-[25px] h-[25px] border-b-2 border-l-2 border-[#1D1615] rounded-bl-2xl"></div>
              </div>
              <div className="absolute bottom-0 right-0 pointer-events-none">
                {/* Bottom-right corner */}
                <div className="w-[25px] h-[25px] border-b-2 border-r-2 border-[#1D1615] rounded-br-2xl"></div>
              </div>
            </div>
            {/* Centered Circular Logo */}
            <div
              className="absolute flex items-center justify-center"
              style={{
                width: 50,
                height: 50,
                borderRadius: "50%",
                backgroundColor: "white",
                overflow: "hidden",
              }}
            >
              <img
                src={imageUrlUserProfile ?? noImageAvialable}
                alt="Logo"
                className="border p-0.5 rounded-full"
                style={{
                  width: "100%", // Ensure image covers the circle
                  height: "100%",
                  objectFit: "cover", // Maintain aspect ratio
                }}
              />
            </div>
          </div>
          <div className="flex justify-center z-50 mt-2">
            <p>{shopShiftGroup[currentIndex]?.local_description}</p>
          </div>
          <div className="absolute -bottom-8 -right-8">
            <img
              className="w-[120px] h-[120px] "
              src={["Club", "Dining Restaurant", "Lunch Restaurant"].includes(userShop?.shop_group) ? logoMoowResturant : logoQrDefaultMenu}
              alt=""
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
